<template>
  <div>
    <!-- 提示小弹窗 -->
    <div class="delete_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleObj.lncompleteHint"
      >
        <div class="delete_mian">
          <i class="iconfont icon-tishi1"></i>
          <p>请填写完整再进行下一步</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="dialogVisibleObj.lncompleteHint = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 组卷模式 -->
    <div class="group_mode">
      <el-dialog title="组卷模式" :visible.sync="dialogVisibleObj.groupmode">
        <div
          @mouseenter="enter(itme, index)"
          @mouseleave="leave(itme, index)"
          @click="changeImg(itme, index)"
          class="mode_item"
          v-for="(itme, index) in groupModeList"
          :key="index"
        >
          <el-tooltip
            class="item"
            :effect="itme.effect"
            :placement="itme.placement"
          >
            <div slot="content" class="prompt">
              {{ itme.text }}
            </div>
            <div
              class="volume_title"
              @click="dialogVisibleObj.groupmode = false"
            >
              <img :src="itme.imgUrl" alt="" />
              <p :class="{ white: itme.isActive }">{{ itme.title }}</p>
            </div>
          </el-tooltip>
        </div>
        <span slot="footer" class="dialog-footer"> </span>
      </el-dialog>
    </div>
    <!-- 命题方式 -->
    <div class="propos_way">
      <el-dialog title="命题方式" :visible.sync="dialogVisibleObj.Proposition">
        <div
          @mouseenter="isSend(itme, index)"
          @mouseleave="isLeave(itme, index)"
          @click="isChangeImg(itme, index)"
          class="mode_item"
          v-for="(itme, index) in propos"
          :key="index"
        >
          <el-tooltip
            class="item"
            :effect="itme.effect"
            :placement="itme.placement"
          >
            <div slot="content" class="prompt">
              {{ itme.text }}
            </div>
            <div
              class="volume_title"
              @click="dialogVisibleObj.Proposition = false"
            >
              <img :src="itme.imgUrl" alt="" />
              <p :class="{ white: itme.isActive }">{{ itme.title }}</p>
            </div>
          </el-tooltip>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisibleObj: {
        lncompleteHint: false,
        groupmode: false,
        Proposition: false,
      },
      facilityState: false, // 难易度状态
      groupModeList: [
        {
          isActive: false,
          type: "intellect",
          title: "智能组卷",
          placement: "right-start",
          effect: "dark1",
          imgUrl: require("@/assets/groupmode/pic1.png"),
          text: "选定好出题范围，设置好考试的题量和分数，系统智能抽取试题。",
        },
        {
          isActive: false,
          type: "paper",
          title: "试卷组卷",
          placement: "left-start",
          effect: "dark2",
          imgUrl: require("@/assets/groupmode/pic2.png"),
          text: "试卷来源于已考过的试卷，设置好考试的题量和分数，系统智能抽取试题",
        },
        {
          isActive: false,
          type: "accuracy",
          title: "精准组卷",
          placement: "right-start",
          effect: "dark1",
          imgUrl: require("@/assets/groupmode/pic3.png"),
          text: "精挑细选每道试题，组卷更直观，所选试题即试卷。",
        },
        {
          isActive: false,
          type: "weight",
          title: "权重组卷",
          placement: "left-start",
          effect: "dark2",
          imgUrl: require("@/assets/groupmode/pic4.png"),
          text: " 选定好出题范围，设置好每个范围需要出题的数量，系统智能抽取试题。",
        },
        // {
        //   isActive: false,
        //   type: "weight",
        //   title: "难易度组卷",
        //   placement: "left-start",
        //   effect: "dark2",
        //   imgUrl: require("@/assets/groupmode/pic4.png"),
        //   text: " 选定好出题范围，设置好每个范围需要出题的数量，系统智能抽取试题。",
        // },
      ],
      propos: [
        {
          isActive: false,
          type: "intellect",
          title: "统一命题",
          placement: "right-start",
          effect: "dark3",
          imgUrl: require("@/assets/groupmode/pro1.png"),
          text: "所有考生使用同一份试卷考试",
        },
        {
          isActive: false,
          type: "paper",
          title: "随机命题",
          placement: "left-start",
          effect: "dark4",
          imgUrl: require("@/assets/groupmode/pro2.png"),
          text: "不同考生之间使用的试卷均不相同",
        },
      ],
    };
  },
  methods: {
    // 组卷移入
    enter(item, index) {
      if (item.isActive) return;
      item.imgUrl = require(`@/assets/groupmode/pica${index + 1}.png`);
    },
    // 组卷移除
    leave(item, index) {
      if (item.isActive) return;
      item.imgUrl = require(`@/assets/groupmode/pic${index + 1}.png`);
    },
    // 组卷点击高亮
    changeImg(item, index) {
      this.$emit("callbackfun", item.title);
      if (item.isActive) {
        item.isActive = false;
        item.imgUrl = require(`@/assets/groupmode/pic${index + 1}.png`);
      } else {
        item.isActive = true;
        item.imgUrl = require(`@/assets/groupmode/pica${index + 1}.png`);
      }
      switch (index) {
        case 0:
          return (this.groupModeList = this.groupModeList.map((item, index) => {
            if (index != 0) {
              item.imgUrl = require(`@/assets/groupmode/pic${index + 1}.png`);
              item.isActive = false;
            }
            return item;
          }));
        case 1:
          return (this.groupModeList = this.groupModeList.map((item, index) => {
            if (index != 1) {
              item.imgUrl = require(`@/assets/groupmode/pic${index + 1}.png`);
              item.isActive = false;
            }
            return item;
          }));
        case 2:
          return (this.groupModeList = this.groupModeList.map((item, index) => {
            if (index != 2) {
              item.imgUrl = require(`@/assets/groupmode/pic${index + 1}.png`);
              item.isActive = false;
            }
            return item;
          }));
        case 3:
          return (this.groupModeList = this.groupModeList.map((item, index) => {
            if (index != 3) {
              item.imgUrl = require(`@/assets/groupmode/pic${index + 1}.png`);
              item.isActive = false;
            }
            return item;
          }));
        case 4:
          return (this.groupModeList = this.groupModeList.map((item, index) => {
            if (index != 4) {
              item.imgUrl = require(`@/assets/groupmode/pic${index + 1}.png`);
              item.isActive = false;
            }
            return item;
          }));
      }
    },
    // 命题移入
    isSend(item, index) {
      if (item.isActive) return;
      item.imgUrl = require(`@/assets/groupmode/prop${index + 1}.png`);
    },
    // 命题移出
    isLeave(item, index) {
      if (item.isActive) return;
      item.imgUrl = require(`@/assets/groupmode/pro${index + 1}.png`);
    },
    // 命题点击高亮
    isChangeImg(item, index) {
      this.$emit("callback", item.title);
      if (item.isActive) {
        item.isActive = false;
        item.imgUrl = require(`@/assets/groupmode/prop${index + 1}.png`);
      } else {
        item.isActive = true;
        item.imgUrl = require(`@/assets/groupmode/prop${index + 1}.png`);
      }
      switch (index) {
        case 0:
          return (this.propos = this.propos.map((item, index) => {
            if (index != 0) {
              item.imgUrl = require(`@/assets/groupmode/pro${index + 1}.png`);
              item.isActive = false;
            }
            return item;
          }));
        case 1:
          return (this.propos = this.propos.map((item, index) => {
            if (index != 1) {
              item.imgUrl = require(`@/assets/groupmode/pro${index + 1}.png`);
              item.isActive = false;
            }
            return item;
          }));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.delete_view {
  .title_box {
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: center !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .delete_mian {
    display: flex;
    padding: 20px 0px;
    box-sizing: border-box;
    i {
      display: inline-block;
      font-size: 16px !important;
      color: #ffc664;
      text-align: center;
      margin-right: 10px;
      transform: translateY(4px);
    }
    p {
      text-align: left;
      font-size: 15px;
    }
  }

  .el-dialog__footer span > button {
    margin-top: 10px;
  }
}
::v-deep .delete_view .el-dialog {
  width: 250px;
  height: 200px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
  }
}
.group_mode {
  ::v-deep .el-dialog__footer {
    margin-bottom: 50px;
    span > .el-button:nth-child(2) {
      margin-left: 50px;
    }
  }
  ::v-deep .el-dialog__body {
    display: flex;
    flex-wrap: wrap;
    padding: 40px 60px;
    box-sizing: border-box;
    div:nth-child(2) {
      text-align: right;
      margin-bottom: 63px;
    }
    div:nth-child(4) {
      text-align: right;
    }
    div:nth-child(5) {
      text-align: left;
      margin-top: 60px;
    }
    .mode_item {
      width: 340px;
      height: 130px;
      border-radius: 5px;
    }

    .title_box {
      padding-bottom: 9px;
      margin-bottom: 20px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 19px;
      color: #333333;
      border-bottom: 1px solid #abd7ff;
      box-sizing: border-box;
      display: flex;
      align-items: center;
    }
    ::v-deep .dialog-footer {
      margin-bottom: 30px;
    }
    ::v-deep.el-dialog__footer {
      justify-content: left !important;
    }
    span > button:nth-child(3) {
      margin-left: 50px;
    }
    ::v-deep .el-dialog__footer span > button:nth-child(2) {
      margin-left: 0;
    }
  }

  .el-dialog__footer span > button {
    margin-top: 10px;
  }
}
::v-deep .group_mode .el-dialog {
  width: 803px;
  // min-height: 560px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
  }
}
.propos_way {
  ::v-deep .el-dialog__footer {
    margin-top: -50px;
    span > .el-button:nth-child(2) {
      margin-left: 50px;
    }
  }
  ::v-deep .el-dialog__body {
    display: flex;
    flex-wrap: wrap;
    padding: 40px 60px 50px 60px;
    box-sizing: border-box;
    div:nth-child(2) {
      text-align: right;
      margin-bottom: 63px;
    }
    div:nth-child(4) {
      text-align: right;
    }
    .mode_item {
      width: 340px;
      height: 130px;
      border-radius: 5px;

      img {
        width: 220px;
        height: 130px;
      }
    }

    .title_box {
      // height: 54px;
      padding-bottom: 9px;
      margin-bottom: 20px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 19px;
      color: #333333;
      border-bottom: 1px solid #abd7ff;
      box-sizing: border-box;
      display: flex;
      align-items: center;
    }
    ::v-deep .dialog-footer {
      margin-bottom: 30px;
    }
    ::v-deep.el-dialog__footer {
      justify-content: left !important;
    }
    span > button:nth-child(3) {
      margin-left: 50px;
    }
    ::v-deep .el-dialog__footer span > button:nth-child(2) {
      margin-left: 0;
    }
  }

  .el-dialog__footer span > button {
    margin-top: -3px;
  }
}
::v-deep .propos_way .el-dialog {
  width: 803px;
  height: 367px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
  }
}
.mian {
  p {
    font-size: 15px;
    margin-bottom: 20px;
  }
}
.volume_title {
  width: 220px;
  height: 130px;
  position: relative;
  display: inline-block;
  &:hover {
    p {
      color: #ffffff !important;
    }
  }
  img {
    width: 220px;
    height: 130px;
  }
  > p {
    position: absolute;
    top: 60px;
    right: 10px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 28px;
    color: #333333;
    opacity: 1;
  }
}
::v-deep .el-dialog__body {
  padding: 14px 20px 0px 20px;
}
.white {
  color: #ffffff !important;
}
.block {
  color: #333333 !important;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
}
</style>